"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    name: 'CardHelp',
    props: {
        name: {
            type: String,
            required: true,
        },
    },
    methods: {
        getClasses() {
            const classes = ['card-help'];
            return classes.join(' ');
        },
        click() {
            window.open(this.url, '_blank');
        },
    },
    computed: {
        url() {
            const anchor = this.name.toLowerCase().replaceAll(' ', '-');
            return 'https://github.com/terraforming-mars/terraforming-mars/wiki/Card-Details#' + anchor;
        },
    },
});
